export const LogoMark = ({ className = "h-9" }) => (
  <img src="/images/logo-mark.png" alt="" aria-hidden="true" className={`${className} w-auto`} />
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3" aria-label="Austyle Plumbing">
    <LogoMark className="h-9 sm:h-10 shrink-0" />
    <span className="leading-none">
      <span className={`block font-wide font-extrabold text-[17px] tracking-tight ${light ? "text-white" : "text-ink"}`}>AUSTYLE</span>
      <span className="block font-mono text-[10px] tracking-[0.34em] mt-1 text-[#7EA6E6]">PLUMBING</span>
    </span>
  </span>
);
